<app-pan-form-control>
  <app-pan-floating-label>{{ label() }}</app-pan-floating-label>
  <ng-select
    data-testid="page-select-location-control"
    appendTo="body"
    [placeholder]="placeholder()"
    [bindLabel]="'name'"
    [virtualScroll]="true"
    [items]="visibleLocations()"
    [multiple]="multi()"
    [ngModel]="selected()"
    (ngModelChange)="selected.set($event)"
    [loading]="isLoading()"
    loadingText="Loading locations..."
    [disabled]="disabled()"
    clearAllText="Clear selection"
    [searchFn]="customSearchFn"
  >
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      @if (multi()) {
        <span class="ng-value-icon left" (click)="clear(item)">×</span>
      }

      <span [class.pl-1]="multi()">{{ item.name }}</span>
      @if (showBranchName() && item.branch_name) {
        (<span class="text-sm italic">{{ item.branch_name }}</span
        >)
      }
    </ng-template>

    <ng-template ng-option-tmp let-item="item">
      <p data-testid="location-option-name">{{ item.name }}</p>
      @if (showBranchName() && item.branch_name) {
        <p class="text-sm italic">{{ item.branch_name }}</p>
      }
    </ng-template>
  </ng-select>
</app-pan-form-control>
